import { useEffect, useRef, useState } from "react";

export const StatCounter = ({ value, prefix = "", suffix, label, testId }) => {
  const [n, setN] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    let raf;
    const obs = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      obs.disconnect();
      const start = performance.now();
      const tick = (t) => {
        const p = Math.min((t - start) / 1800, 1);
        setN(Math.round(value * (1 - Math.pow(1 - p, 3))));
        if (p < 1) raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
    });
    obs.observe(ref.current);
    return () => { obs.disconnect(); cancelAnimationFrame(raf); };
  }, [value]);

  return (
    <div ref={ref} className="border-l-2 border-[#e02424] pl-4" data-testid={testId}>
      <p className="dz-heading text-4xl sm:text-5xl font-black text-white leading-none">
        {prefix}{n}<span className="text-[#e02424]">{suffix}</span>
      </p>
      <p className="dz-mono text-xs uppercase tracking-[0.25em] text-zinc-400 mt-2">{label}</p>
    </div>
  );
};
